import React, { useEffect, useState } from "react";
import ClaimInformation from "../../organisms/KNT/ClaimInformation";
import useStepPersistence from "../../Hooks/useStepPersistience";
import axios from "../../../Http";
import * as Http from "../../../Http";
import { ReadableDateTime } from "../../../helpers/Date";
const ClaimInformationContainer = ({ formData, setFormStep, loading, }) => {
    const [informationLoading, setInformationLoading] = useState(false);
    const [data, , handleSubmit, patch] = useStepPersistence({
        licence_plate: "",
        offence_place: "",
        offence_municipality: "",
        offence_date: "",
    }, formData, setFormStep);
    useEffect(() => {
        if (formData.license_plate) {
            return;
        }
        setInformationLoading(true);
        axios
            .get(Http.CLAIM_SPECIFICATION)
            .then((data) => {
            patch(Object.assign(Object.assign({}, data.data), { offence_date: ReadableDateTime(data.data.offence_date) }));
            setInformationLoading(false);
        })
            .catch(() => {
            setInformationLoading(false);
        });
    }, [formData]);
    return (React.createElement(ClaimInformation, { onSubmit: handleSubmit, data: Object.assign(Object.assign({}, formData), data), loading: loading || informationLoading }));
};
export default ClaimInformationContainer;
